import styles from "./PlatformBadge.module.css";

export type PlatformKey = "ig" | "fb" | "tt";

const MAP: Record<PlatformKey, { label: string; varName: string }> = {
  ig: { label: "IG", varName: "--platform-ig" },
  fb: { label: "f", varName: "--platform-fb" },
  tt: { label: "♪", varName: "--platform-tt" },
};

/** Maps the full platform name to the design's short key. */
export function toPlatformKey(platform: string): PlatformKey {
  if (platform === "facebook" || platform === "fb") return "fb";
  if (platform === "tiktok" || platform === "tt") return "tt";
  return "ig";
}

interface PlatformBadgeProps {
  platform: PlatformKey;
  size?: number;
}

export function PlatformBadge({ platform, size = 18 }: PlatformBadgeProps) {
  const p = MAP[platform];
  return (
    <span
      className={styles.badge}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.5,
        background: `var(${p.varName})`,
      }}
    >
      {p.label}
    </span>
  );
}
